"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const home_png_1 = __importDefault(require("../assets/home.png"));
const ms_login_svg_1 = __importDefault(require("../assets/ms-login.svg"));
const gh_login_png_1 = __importDefault(require("../assets/gh-login.png"));
const LandingPage = () => {
    return (React.createElement("section", { className: "container" },
        React.createElement("div", { className: "boxes teasers" },
            React.createElement("div", { className: "teaser text-center center" },
                React.createElement("img", { style: { maxWidth: '300px' }, src: home_png_1.default, alt: "Piral Logo" })),
            React.createElement("div", { className: "teaser" },
                React.createElement("h2", null, "Welcome to the Piral Cloud Partner Portal!"),
                React.createElement("p", null,
                    "The ",
                    React.createElement("strong", null, "Piral Cloud Partner Portal"),
                    " offers access to your subscriptions and other information regarding the Piral Cloud products. Once registered, it allows you to manage your licenses or to sign-up for the evaluation of new services."),
                React.createElement("p", null,
                    "A ",
                    React.createElement("strong", null, "Microsoft"),
                    " or ",
                    React.createElement("strong", null, "GitHub Account"),
                    " is required for the sign-up and later login after successful registration."))),
        React.createElement("div", { className: "login-buttons" },
            React.createElement("a", { href: "/login/microsoft" },
                React.createElement("img", { src: ms_login_svg_1.default, alt: "Microsoft Login", "data-eid": "login" })),
            React.createElement("a", { href: "/login/github", "data-eid": "github-login" },
                React.createElement("img", { src: gh_login_png_1.default, alt: "GitHub Login" })))));
};
exports.default = LandingPage;
